/** @format */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const utilityGetFromLocalStorage = (ref: string): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const storage: any = localStorage.getItem(ref);
  return storage ? JSON.parse(storage) : {};
};
